import axios from 'axios';
import { keccak256 } from 'viem';
import { IRIS_API_URL } from '../../config/cctp/chains';

export const fetchAttestation = async (transactionHash, sourceDomain, maxRetries = 60, retryInterval = 5000) => {
  let attempts = 0;
  console.log(`Starting attestation fetch for transaction hash: ${transactionHash}`);
  console.log(`Source domain: ${sourceDomain}`);
  
  // For CCTP V2, use the /v2/messages endpoint with source domain in path and transaction hash as query param
  const apiUrl = `${IRIS_API_URL}/v2/messages/${sourceDomain}?transactionHash=${transactionHash}`;
  console.log(`API URL: ${apiUrl}`);
  
  while (attempts < maxRetries) {
    try {
      const response = await axios.get(apiUrl);
      
      console.log(`Attestation API response (attempt ${attempts + 1}):`, {
        status: response.status,
        hasData: !!response.data,
        data: response.data
      });
      
      // V2 API response structure includes messages array
      if (response.data && response.data.messages && response.data.messages.length > 0) {
        const message = response.data.messages[0];
        
        // Check if attestation is complete or has enough confirmations
        if ((message.status === 'complete' || message.status === 'pending_confirmations') && message.attestation) {
          console.log(`Attestation found! Status: ${message.status}`);
          // Return the full response to get both attestation and message
          return response.data;
        }
        
        // Log status if pending
        if (message.status === 'pending') {
          console.log(`Attestation pending, attempt ${attempts + 1}/${maxRetries}`);
        }
      }
    } catch (error) {
      if (error.response?.status === 404) {
        console.log(`Message not found yet (404), attempt ${attempts + 1}/${maxRetries}`);
      } else {
        console.error('Error fetching attestation:', {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data
        });
      }
    }
    
    attempts++;
    if (attempts < maxRetries) {
      console.log(`Waiting ${retryInterval/1000} seconds before retry...`);
      await new Promise(resolve => setTimeout(resolve, retryInterval));
    }
  }
  
  throw new Error(`Failed to fetch attestation after ${maxRetries} attempts (${maxRetries * retryInterval / 1000} seconds)`);
};

export const getMessageHashFromLogs = (receipt) => {
  const messageSentTopic = '0x8c5261668696ce22758910d05bab8f186d6eb247ceac2af2e82c7dc17669b036';
  
  console.log('Looking for MessageSent event in logs...');
  
  const messageSentLog = receipt.logs.find(log => {
    // Check if topics exists and has at least one element
    return log.topics && log.topics[0] === messageSentTopic;
  });
  
  if (!messageSentLog) {
    console.error('Logs in receipt:', receipt.logs);
    throw new Error('MessageSent event not found in transaction logs');
  }
  
  console.log('Found MessageSent log:', messageSentLog);
  console.log('Message data:', messageSentLog.data);
  
  // For CCTP v2, the message hash is computed from the message bytes
  // The message bytes are in the data field of the MessageSent event
  const messageBytes = messageSentLog.data;
  
  // Compute the keccak256 hash of the message bytes
  const messageHash = keccak256(messageBytes);
  
  console.log('Computed message hash from message bytes:', messageHash);
  
  return messageHash;
};

export const addressToBytes32 = (address) => {
  return '0x000000000000000000000000' + address.slice(2).toLowerCase();
};